<div class="content">
  <button class="close" mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <app-page-subheader
    class="col-12"
    icon="building"
    [title]="
      !!data.title
        ? data.title
        : isMultipleSelection
          ? ('LOCATIONS.SELECT_LOCATIONS' | translate)
          : ('LOCATIONS.SELECT_LOCATION' | translate)
    "
  ></app-page-subheader>
  <form [formGroup]="form" class="filter-form">
    <app-geo-loader *ngIf="isLoading"></app-geo-loader>
    <mat-form-field class="default">
      <mat-label>{{ 'LOCATIONS.SEARCH' | translate }}</mat-label>
      <input matInput formControlName="search" />
      <mat-icon
        class="mat-icon-rtl-mirror"
        matPrefix
        svgIcon="search"
      ></mat-icon>
    </mat-form-field>
    @if (data.withNetwork) {
      <mat-form-field>
        <mat-label>{{ 'LOCATIONS.CHANNEL' | translate }}</mat-label>
        <mat-select formControlName="channel" tx-content="exclude">
          <mat-option value="google">
            {{ 'LOCATIONS.GOOGLE' | translate }}
          </mat-option>
          <mat-option value="facebook">
            {{ 'LOCATIONS.FACEBOOK' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field *ngIf="!data?.brandId">
      <mat-label>{{ 'LOCATIONS.BRAND' | translate }}</mat-label>
      <mat-select formControlName="brandIds" multiple tx-content="exclude">
        <mat-option [value]="item.id" *ngFor="let item of brands">{{
          item.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    @if (form.value.channel === 'google') {
      <mat-form-field>
        <mat-label>{{ 'LOCATIONS.TAG' | translate }}</mat-label>
        <mat-select formControlName="tagIds" multiple tx-content="exclude">
          <mat-option [value]="item.id" *ngFor="let item of tags">{{
            item.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    }
    <button type="button" class="text-button" (click)="clearFilter()">
      {{ 'LOCATIONS.CLEAR_FILTER' | translate }}
    </button>
  </form>
  <ng-container
    *ngIf="
      ((form.value.channel === 'google' && this.dataSource.data.length === 0) ||
        (form.value.channel !== 'google' &&
          this.socialMediaDataSource.data.length === 0)) &&
        !isLoading;
      else hasLocation
    "
  >
    <h1 class="no-state">{{ 'LOCATIONS.NO_LOCATION_GIVEN' | translate }}</h1>
  </ng-container>
  <div *ngIf="isLoading" class="loading-space"></div>
  <ng-template #hasLocation>
    <ng-container *ngIf="!isLoading">
      @if (form.value.channel === 'google') {
        <div class="table-wrap">
          <div class="header" *ngIf="showSelectAllLocationBanner">
            <div class="header-start">
              <span> {{ 'LOCATIONS.YOU_SELECTED' | translate }} </span>
              <span class="notranslate">
                {{
                  paging.totalCount === selection.selected.length
                    ? ('LOCATIONS.ALL' | translate)
                    : ''
                }}
                {{ selection.selected.length }}
              </span>
              <span>
                {{ 'LOCATIONS.YOU_SELECTED_LOCATIONS' | translate }}
              </span>
              <button
                class="button-link"
                type="button"
                (click)="selectAllLocations()"
                *ngIf="paging.totalCount > selection.selected.length"
              >
                {{ 'LOCATIONS.CLICK_HERE_TO_SELECT_LOCATIONS' | translate }}
              </button>
              <button
                class="button-link"
                type="button"
                (click)="clearAllSelections()"
                *ngIf="paging.totalCount === selection.selected.length"
              >
                {{ 'LOCATIONS.CLICK_HERE_TO_CLEAR_LOCATIONS' | translate }}
              </button>
            </div>
          </div>
          <mat-table [dataSource]="dataSource">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="!data.inViewMode">
                  <mat-checkbox
                    *ngIf="isMultipleSelection"
                    color="primary"
                    (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                  >
                  </mat-checkbox>
                </ng-container>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleSelection(row.id) : null"
                  [checked]="selection.isSelected(row.id)"
                  [disabled]="data.inViewMode"
                >
                </mat-checkbox>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="location">
              <mat-header-cell *matHeaderCellDef>
                {{ 'LOCATIONS.LOCATION' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div class="d-flex flex-column" tx-content="exclude">
                  <span>{{ element.name }}</span>
                  <span class="store-code">{{ element.storeCode }}</span>
                  <span class="sub">{{ element.address }}</span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="verified">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>

              <mat-cell *matCellDef="let element">
                <mat-icon
                  class="material-symbols-outlined"
                  *ngIf="element.verificationStatus === 'VERIFIED'"
                >
                  verified
                </mat-icon>

                <span *ngIf="element.verificationStatus !== 'VERIFIED'">
                  {{ 'LOCATIONS.NOT_VERIFIED' | translate }}
                </span>

                <span *ngIf="element.verificationStatus === 'VERIFIED'">
                  {{ 'LOCATIONS.VERIFIED' | translate }}
                </span>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              [ngClass]="{ select: selection.isSelected(row) }"
            ></mat-row>
          </mat-table>
          <div class="footer">
            <span class="selection-description">
              <span *ngIf="selection.hasValue()" class="notranslate"
                >{{ selection.selected.length | numberTranslate }}
              </span>
              {{
                selection.hasValue()
                  ? ('LOCATIONS.LOCATION_SELECTED' | translate)
                  : ''
              }}
            </span>
            <app-paging
              *ngIf="!!paging.totalCount"
              [pageSize]="pageSize"
              [pageIndex]="paging.pageIndex"
              [totalCount]="paging.totalCount"
              (changePage)="handleChangePage($event)"
            ></app-paging>
          </div>
        </div>
      } @else {
        <div class="table-wrap">
          <div class="header" *ngIf="showSelectAllLocationBanner">
            <div class="header-start">
              <span> {{ 'LOCATIONS.YOU_SELECTED' | translate }} </span>
              <span class="notranslate">
                {{
                  paging.totalCount === selection.selected.length
                    ? ('LOCATIONS.ALL' | translate)
                    : ''
                }}
                {{ selection.selected.length }}
              </span>
              <span>
                {{ 'LOCATIONS.YOU_SELECTED_LOCATIONS' | translate }}
              </span>
              <button
                class="button-link"
                type="button"
                (click)="selectAllLocations()"
                *ngIf="paging.totalCount > selection.selected.length"
              >
                {{ 'LOCATIONS.CLICK_HERE_TO_SELECT_LOCATIONS' | translate }}
              </button>
              <button
                class="button-link"
                type="button"
                (click)="clearAllSelections()"
                *ngIf="paging.totalCount === selection.selected.length"
              >
                {{ 'LOCATIONS.CLICK_HERE_TO_CLEAR_LOCATIONS' | translate }}
              </button>
            </div>
          </div>
          <mat-table [dataSource]="socialMediaDataSource">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="!data.inViewMode">
                  <mat-checkbox
                    *ngIf="isMultipleSelection"
                    color="primary"
                    (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                  >
                  </mat-checkbox>
                </ng-container>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleSelection(row.id) : null"
                  [checked]="selection.isSelected(row.id)"
                  [disabled]="data.inViewMode"
                >
                </mat-checkbox>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="location">
              <mat-header-cell *matHeaderCellDef>
                {{ 'LOCATIONS.LOCATION' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div class="d-flex flex-column" tx-content="exclude">
                  <span>{{ element.name }}</span>
                  <span class="store-code">{{ element.storeCode }}</span>
                  <span class="sub"
                    >{{ element.address?.addressLine1 }}
                    {{ element.address.addressLine2 }}</span
                  >
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="socialMediaDisplayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: socialMediaDisplayedColumns"
              [ngClass]="{ select: selection.isSelected(row) }"
            ></mat-row>
          </mat-table>
          <div class="footer">
            <span class="selection-description">
              <span *ngIf="selection.hasValue()" class="notranslate"
                >{{ selection.selected.length | numberTranslate }}
              </span>
              {{
                selection.hasValue()
                  ? ('LOCATIONS.LOCATION_SELECTED' | translate)
                  : ''
              }}
            </span>
            <app-paging
              *ngIf="!!paging.totalCount"
              [pageSize]="pageSize"
              [pageIndex]="paging.pageIndex"
              [totalCount]="paging.totalCount"
              (changePage)="handleChangePage($event)"
            ></app-paging>
          </div>
        </div>
      }
    </ng-container>
  </ng-template>
  <button
    class="full-button"
    *ngIf="!data.inViewMode"
    (click)="submitForm()"
    [disabled]="!selection.selected.length && data.disableSubmitWhenEmpty"
  >
    {{ data.buttonLabel ? data.buttonLabel : ('LOCATIONS.SELECT' | translate) }}
  </button>
</div>
